

export interface NavLink {
    title: string;
    href: string;
    extraText?: string;
    submenuHeader?: string;
    submenu?: NavLink[];
}

export const navLinks: NavLink[] = [
    {
        title: "Home",
        href: "/",
    },
    // {
    //     title: "About",
    //     href: "/about",
    //     submenu: [
    //         { title: "Welcome", href: "/about#welcome" },
    //         { title: "Divisional Leadership", href: "/under-construction" },
    //         { title: "History + Governance (PTA + School Board)", href: "/under-construction" },
    //         { title: "CIC (Website)", href: "/under-construction" },
    //     ]
    // },
    {
        title: "About",
        href: "#",
        submenu: [
            { title: "Welcome", href: "/about/welcome" },
            { title: "Divisional Leadership", href: "/about/leadership" },
            { title: "History", href: "/about/history" },
            { title: "Governance", href: "/governance" },
            { title: "School Board", href: "/school/board" },
            { title: "Parent-Teacher Association", href: "/pta" },
            { title: "Cayman Islands Conference ", href: "/about/clc" },
        ],
    },
    {
        title: "School Life",
        href: "#",
        submenu: [
            { title: "Events", href: "/event" },
            { title: "Newsletter", href: "/news" },
            {
                title: "Extra-Curricular",
                href: "/school/extraCurricular",
                submenu: [
                    {
                        title: "Term 1 (Fall) - Aug to Dec",
                        href: "#",
                        submenu: [
                            { title: "Art & Craft", href: "#" },
                            { title: "Choir", href: "#" },
                            { title: "Drama", href: "#" },
                            { title: "Netball & Football", href: "#" },
                            { title: "Pathfinder", href: "#" },
                            { title: "Spelling Bee", href: "#" },
                        ]
                    },
                    {
                        title: "Term 2 (Spring) - Jan to March",
                        href: "#",
                        submenu: [
                            { title: "Cheerleading", href: "#" },
                            { title: "Chess", href: "#" },
                            { title: "Choir", href: "#" },
                            { title: "Debate", href: "#" },
                            { title: "Financial Literacy", href: "#" },
                            { title: "Journalism/Media", href: "#" },
                            { title: "Pathfinder", href: "#" },
                            { title: "Peer Club", href: "#" },
                            { title: "Spelling", href: "#" },
                            { title: "Track and field", href: "#" },
                        ]
                    },
                    {
                        title: "Term 3 (Easter)",
                        href: "#",
                        submenu: [
                            { title: "4-H", href: "#" },
                            { title: "Art & Craft", href: "#" },
                            { title: "Chess", href: "#" },
                            { title: "Choir", href: "#" },
                            { title: "Pathfinder", href: "#" },
                            { title: "Vacational (AC Repairs)", href: "#" },
                        ]
                    },
                    {
                        title: "Lunch Time",
                        href: "#",
                        submenu: [
                            { title: "Builder’s (High)", href: "#" },
                            { title: "Key club (High)", href: "#" },
                            { title: "Y2Y club (Youth Service)", href: "#" },
                        ]
                    },
                    {
                        title: "Seasonal Sports",
                        href: "#",
                        submenu: [
                            { title: "Sports (Basketball-Primary)", href: "#" },
                            { title: "Sports (Cricket-Primary)", href: "#" },
                            { title: "Sports (Football-Primary)", href: "#" },
                            { title: "Sports (Netball-Primary)", href: "#" },
                            { title: "Sports (Volleyball-Primary)", href: "#" },
                            { title: "Sports (Basketball-High)", href: "#" },
                            { title: "Sports (Cricket-High)", href: "#" },
                            { title: "Sports (Football-High)", href: "#" },
                            { title: "Sports (Netball-High)", href: "#" },
                            { title: "Sports (Volleyball-High)", href: "#" },
                        ]
                    },
                    {
                        title: "Primary Club List (3:30-4:30)",
                        href: "#",
                        submenu: [
                            { title: "Adventurers’ Club", href: "#" },
                            { title: "Art - Monday", href: "#" },
                            { title: "Drama- Monday", href: "#" },
                            { title: "Sign language - Thursday", href: "#" },
                            { title: "Spelling - Wednesday", href: "#" },
                        ]
                    },
                    {
                        title: "After School",
                        href: "#",
                        submenu: [
                            { title: "Sign language", href: "#" },
                        ]
                    },
                ]
            },
            { title: "School Calendar", href: "/school/calendar" },
        ],
    },
    {
        title: "Admission",
        href: "/admission",
        submenu: [
            { title: "Admission Policy", href: "/admission/policy" },
            // { title: "Primary Application", href: "/primary-application" },
            // { title: "High School Application", href: "/high-school-application" },
            { title: "Tuitions", href: "/tuitions" },
            {
                title: "Uniform",
                href: "/uniform",
                submenuHeader: "Classes",
                submenu: [
                    { title: "K1 School", href: "/uniform#k1-school" },
                    { title: "K2 - Year 4", href: "/uniform#k2-year4" },
                    { title: "Year 5-6", href: "/uniform#year5-6" },
                    { title: "High School", href: "/uniform#high-school" },
                ],
            },
            { title: "Book A Visit", href: "/contact" },
            { title: "Apply Now", href: "/admission" },
            { title: "Track Application", href: "/track-application" },
            { title: "CXC Registration", href: "/cxc-registration" },
        ],
    },
    {
        title: "Learning & Teaching",
        href: "#",
        submenu: [
            {
                title: "Early Learning Center",
                href: "/learning/elc",
                submenuHeader: "Subjects",
                submenu: [
                    { title: "Bible", href: "#" },
                    { title: "Literacy", href: "#" },
                    { title: "Numeracy", href: "#" },
                    { title: "Science", href: "#" },
                    { title: "Social Studies", href: "#" },
                    { title: "Understanding the World", href: "#" },
                ],
            },
            {
                title: "Primary Division",
                href: "/learning/primary",
                extraText: " (Key Stage 1)",
                submenuHeader: "Subjects",
                submenu: [
                    { title: "Creative Writing", href: "#" },
                    { title: "Science", href: "#" },
                    { title: "Art & Craft", href: "#" },
                    { title: "Bible", href: "#" },
                    { title: "Grammar", href: "#" },
                    { title: "Information Technology", href: "#" },
                    { title: "Mathematics", href: "#" },
                    { title: "Phonics", href: "#" },
                    { title: "Reading Comprehension", href: "#" },
                    { title: "Social Studies", href: "#" },
                    { title: "Spellings", href: "#" },
                ],
            },
            {
                title: "High School",
                href: "/learning/high",
                extraText: " (Key Stage 2)",
                submenuHeader: "Subjects",
                submenu: [
                    { title: "Bible", href: "#" },
                    { title: "Biology", href: "#" },
                    { title: "Caribbean History", href: "#" },
                    { title: "Business Studies", href: "#" },
                    { title: "Chemistry", href: "#" },
                    {
                        title: "Electronic Document Preparation and Management (EDPM)",
                        href: "#",
                    },
                    { title: "English Language", href: "#" },
                    { title: "English Literature", href: "#" },
                    { title: "Geography", href: "#" },
                    { title: "Home Management", href: "#" },
                    { title: "Human and Social Biology", href: "#" },
                    { title: "Information Technology", href: "#" },
                    { title: "Integrated Science", href: "#" },
                    { title: "Mathematics", href: "#" },
                    { title: "Modern Languages - Spanish", href: "#" },
                    { title: "Music", href: "#" },
                    { title: "Physical Education", href: "#" },
                    { title: "Physical Education and Sport (CSEC)", href: "#" },
                    { title: "Physics", href: "#" },
                    { title: "Principles of Accounts", href: "#" },
                    { title: "Principles of Business", href: "#" },
                    { title: "Social Studies", href: "#" },
                ],
            },
            {
                title: "Adventist Materials",
                href: "/learning/adventist-materials",
            },
            {
                title: "Adventist Virtual Library",
                href: "/learning/virtual-library",
            },
            { title: "Learning Support", href: "/learning/learning-support" },
        ],
    },

    {
        title: "Career",
        href: "/career",
        submenu: [{ title: "Job Openings", href: "/career" }],
    },

    {
        title: "Testimonials",
        href: "/testimonials",
        submenu: [
            { title: "Inspection Report", href: "/testimonials#inspection" },
            { title: "Past Students", href: "/students" },
            { title: "Past Parents", href: "/parents" },
            { title: "Past Teachers", href: "/teachers" },
        ],
    },
];

export const mobileOnlyLinks: NavLink[] = [
    { title: "Enroll Now", href: "/enquiryPage" },
];
